import { inject, Injectable } from '@angular/core';
import { ODataEntities, ODataEntitySetService, ODataServiceFactory } from 'angular-odata';
import { Observable } from 'rxjs';
import { CoaterLicense } from '@workspace-app/odatabackend/QualicoatBackendModel';
import {
  CoaterLicenseFilter,
  CoaterLicensePagination,
  convertToFilterString,
  convertToOrderByString,
  LicenseOrderBy,
} from '../license.state';

@Injectable({
  providedIn: 'root',
})
export class LicenseDataService {
  private factory = inject(ODataServiceFactory);

  licenseNumberService: ODataEntitySetService<CoaterLicense>;
  
  constructor() {
    this.licenseNumberService = this.factory.entitySet<CoaterLicense>(
      'Licenses',
      'QualicoatBackend.Features.Certification.License'
    );
  }

  public fetchLicenseNumbers(
    filter: CoaterLicenseFilter,
    orderBy: LicenseOrderBy,
    pagination: CoaterLicensePagination
  ): Observable<ODataEntities<CoaterLicense>> {
    return this.licenseNumberService.entities()
      ?.query((q) => {
        if (filter !== null) q.filter(convertToFilterString(filter));
        if (orderBy !== null && orderBy.field) q.orderBy(convertToOrderByString(orderBy));
        q.top(pagination.currentPage * pagination.pageSize);
        q.skip((pagination.currentPage - 1) * pagination.pageSize);
        q.expand('ProductionSite($expand=Customer,Contact)');
      })
      .fetch({ withCount: true });
  }

  withdrawLicense(licenseNumberId: string, withdrawalDate: Date, withdrawalReason: string) {
    return this.licenseNumberService.update(licenseNumberId, {
      withdrawalDate: withdrawalDate.toUTCString(),
      withdrawalReason,
    });
  }

  grantLicense(licenseNumberId: string, expiryDate: Date) {
    return this.licenseNumberService.update(licenseNumberId, { expiryDate: expiryDate.toUTCString() });
  }
}
